import React from 'react';


export function AppLogo({size}: {size: number}) {
    return (
        <img alt={"Docul Logo"} src='./logos/doculLogo.svg' width={size}/>
    );
}

